import * as React from 'react';
import {EditBreadcrumb, IState} from "./Data";
import {RouteComponentProps} from "react-router";
import {CreateLayout} from "../../layout/CreateLayout";
import { ResourceModel} from "../../model";
import {ResourceForm} from "./form/ResourceForm";
import {ResourceService } from "../../services";

export class ResourceEdit extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      resource: {} as ResourceModel
    }
  }

  init = async () => {
    const resource: ResourceModel = await ResourceService.get(this.state.id)
    this.setState({
      resource
    })
  }

  componentDidMount() {
    this.init();
  }

  render() {
    return (
        <CreateLayout breadcrumb={EditBreadcrumb} title={'Edit'}>
          <ResourceForm {...this.state}/>
        </CreateLayout>
    )
  }
}